import { BarChartStrategy } from "../chartStrategies/BarChartStrategy";
import { LineChartStrategy } from "../chartStrategies/LineChartStrategy";
import { AreaChartStrategy } from "../chartStrategies/AreaChartStrategy";
import { PieChartStrategy } from "../chartStrategies/PieChartStrategy";
import { ScatterChartStrategy } from "../chartStrategies/ScatterChartStrategy";
import { RadarChartStrategy } from "../chartStrategies/RadarChartStrategy";
import { HeatmapStrategy } from "../chartStrategies/HeatMapStrategy";
import { TreemapStrategy } from "../chartStrategies/TreeMapStrategy";
import { FunnelChartStrategy } from "../chartStrategies/FunnelChartStrategy";
import { TableStrategy } from "../chartStrategies/TableStrategy";

export const ChartFactory = {
  create(chartType, props) {
    const strategies = {
      bar: () => new BarChartStrategy(props),
      histogram: () => new BarChartStrategy(props),
      waterfall: () => new BarChartStrategy(props),
      line: () => new LineChartStrategy(props),
      area: () => new AreaChartStrategy(props),
      pie: () => new PieChartStrategy(props),
      donut: () => new PieChartStrategy(props),
      scatter: () => new ScatterChartStrategy(props),
      bubble: () => new ScatterChartStrategy(props),
      radar: () => new RadarChartStrategy(props),
      treemap: () => new TreemapStrategy(props),
      funnel: () => new FunnelChartStrategy(props),
      heatmap: () => new HeatmapStrategy(props),
      table: () => new TableStrategy(props),
    };

    const strategyCreator = strategies[chartType];
    return strategyCreator ? strategyCreator() : null;
  },
};
